export const DOMAIN = process.env.REACT_APP_DOMAIN;
export const REACT_APP_CLIENT_URL = process.env.REACT_APP_CLIENT_URL;
export const REACT_APP_CORE_API = process.env.REACT_APP_CORE_API;

export const IS_LOCALHOST = !window?.location.href.includes(DOMAIN);
